/**
 * Billing success (/billing/success) — T7.
 *
 * Stripe Checkout redirects here after a successful subscription. Shows a
 * confirmation, then routes the merchant into onboarding continuation:
 * /welcome if onboarding is incomplete, /dashboards otherwise — the same
 * resolution App.tsx's `/` route uses (services/onboardingApi.ts's
 * resolveOnboardingDestination), so the two never disagree about what
 * "done" means.
 */

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BlockStack, Button, Card, Layout, Page, Text } from '@shopify/polaris';

import { resolveOnboardingDestination } from '../services/onboardingApi';

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [destination, setDestination] = useState<'/welcome' | '/dashboards' | null>(
    null
  );

  useEffect(() => {
    let cancelled = false;
    resolveOnboardingDestination().then((dest) => {
      if (!cancelled) setDestination(dest);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Page title="Subscription confirmed">
      <Layout>
        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h1" variant="headingLg">
                You&apos;re all set.
              </Text>
              <Text as="p" tone="subdued">
                Your subscription is active. Stripe will email you a receipt
                shortly.
              </Text>
              <Button
                variant="primary"
                loading={destination === null}
                onClick={() => destination && navigate(destination)}
              >
                Continue
              </Button>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
